<div class="award-simulation-section"
     [attr.aria-labelledby]="idPrefix + 'SimulationHeading'"
     [attr.data-qa]="idPrefix + 'SimulationSection'"
     [attr.data-pw]="idPrefix + 'SimulationSection'">
  <h2 [id]="idPrefix + 'SimulationHeading'" class="visually-hidden">Award Simulation</h2>

  <form [formGroup]="awardSimulationForm"
        class="simulation-form"
        [attr.data-qa]="idPrefix + 'SimulationForm'"
        [attr.data-pw]="idPrefix + 'SimulationForm'">
    <div class="form-labels">
      <label [id]="idPrefix + 'AwardSimulationTypeLabel'"
             [for]="idPrefix + 'AwardSimulationType'"
             class="form-label">
        Award Simulation through
      </label>
      @if (!showDateRangePicker) {
        <label [id]="idPrefix + 'SimulationInputValueLabel'"
               [for]="idPrefix + 'SimulationInputValue'"
               class="form-label">
          {{ secondInputLabel }}
        </label>
      } @else {
        <label [id]="idPrefix + 'DateRangeLabel'"
               [for]="idPrefix + 'StartDate'"
               class="form-label">
          {{ secondInputLabel }}
        </label>
      }
    </div>

    <div class="form-row">
      <!-- Dropdown for Award Simulation Type -->
      <mat-form-field appearance="outline"
                      class="simulation-dropdown"
                      [attr.data-qa]="idPrefix + 'SimulationTypeField'"
                      [attr.data-pw]="idPrefix + 'SimulationTypeField'">
        <mat-select formControlName="simulationType"
                    [id]="idPrefix + 'AwardSimulationType'"
                    [attr.data-qa]="idPrefix + 'AwardSimulationType_select'"
                    [attr.data-pw]="idPrefix + 'AwardSimulationType_select'"
                    [attr.aria-labelledby]="idPrefix + 'AwardSimulationTypeLabel'">
          <mat-option disabled value="">Please Select</mat-option>
          @for (option of simulationOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
        @if (awardSimulationForm.get('simulationType')?.hasError('required')) {
          <mat-error>
            Award simulation type is required
          </mat-error>
        }
      </mat-form-field>

      @if (!showDateRangePicker) {
        <mat-form-field appearance="outline"
                        class="simulation-input"
                        [attr.data-qa]="idPrefix + 'SimulationInputField'"
                        [attr.data-pw]="idPrefix + 'SimulationInputField'">
          @if(awardSimulationForm.get('simulationType')?.value === 'pid'){
             <input matInput
              type="text"
              inputmode="numeric"
              formControlName="inputValue"
              [placeholder]="secondInputPlaceholder"
              [id]="idPrefix + 'SimulationInputValue'"
              [attr.data-qa]="idPrefix + 'SimulationInputValue'"
              [attr.data-pw]="idPrefix + 'SimulationInputValue'"
              [attr.aria-labelledby]="idPrefix + 'SimulationInputValueLabel'"
              [matAutocomplete]="pidAutocomplete" />

              <mat-autocomplete
                #pidAutocomplete="matAutocomplete"
                (optionSelected)="onPidStudentSelected($event.option.value)">
                @for (student of pidSearchResults; track student.id) {
                  <mat-option [value]="student">
                    {{ student.fullName }} - {{ student.pidNumber }}
                  </mat-option>
                }
              </mat-autocomplete>
          } @else {
                <input matInput
                 formControlName="inputValue"
                 [type]="getInputType()"
                 [step]="getInputStep()"
                 inputmode="decimal"
                 [min]="0"
                 [placeholder]="secondInputPlaceholder"
                 [id]="idPrefix + 'SimulationInputValue'"
                 [attr.data-qa]="idPrefix + 'SimulationInputValue'"
                 [attr.data-pw]="idPrefix + 'SimulationInputValue'"
                 [attr.aria-labelledby]="idPrefix + 'SimulationInputValueLabel'" />
          }
   
          @if (awardSimulationForm.get('inputValue')?.hasError('required')) {
            <mat-error>
              {{ secondInputLabel }} is required
            </mat-error>
          }
          @if (awardSimulationForm.get('inputValue')?.hasError('pattern')) {
            <mat-error>
              Please enter a valid {{ secondInputLabel.toLowerCase() }}
            </mat-error>
          }
        </mat-form-field>
      }

      @if (showDateRangePicker) {
        <mat-form-field appearance="outline"
                        class="simulation-input date-range-field"
                        [attr.data-qa]="idPrefix + 'DateRangeField'"
                        [attr.data-pw]="idPrefix + 'DateRangeField'">
          <mat-date-range-input style="background-color: white;"
                                  [attr.aria-labelledby]="idPrefix + 'DateRangeLabel'"
                                  [rangePicker]="awardAppliedPicker">
            <input matStartDate
                   formControlName="startDate"
                   placeholder="MM/DD/YYYY"
                   [id]="idPrefix + 'StartDate'"
                   [attr.data-qa]="idPrefix + 'StartDate_input'"
                   [attr.data-pw]="idPrefix + 'StartDate_input'">
            <input matEndDate
                   formControlName="endDate"
                   placeholder="MM/DD/YYYY"
                   [id]="idPrefix + 'EndDate'"
                   [attr.data-qa]="idPrefix + 'EndDate_input'"
                   [attr.data-pw]="idPrefix + 'EndDate_input'">
          </mat-date-range-input>
          <mat-date-range-picker #awardAppliedPicker
                                startView="year"
                                [attr.data-qa]="idPrefix + 'AwardApplied_daterange_picker'"
                                [attr.data-pw]="idPrefix + 'AwardApplied_daterange_picker'">
          </mat-date-range-picker>
          <mat-datepicker-toggle matSuffix
                                [for]="awardAppliedPicker"
                                [attr.data-qa]="idPrefix + 'DatePickerToggle'"
                                [attr.data-pw]="idPrefix + 'DatePickerToggle'"
                                [disableRipple]="true">
          </mat-datepicker-toggle>
          @if (awardSimulationForm.get('startDate')?.hasError('required')) {
            <mat-error>
              Start date is required
            </mat-error>
          }
          @if (awardSimulationForm.get('endDate')?.hasError('required')) {
            <mat-error>
              End date is required
            </mat-error>
          }
          @if (awardSimulationForm.hasError('startDateInPast')) {
            <div class="date-range-validation-error">
              Start date must be current date or greater than current date
            </div>
          }
          @if (awardSimulationForm.hasError('endDateInPast')) {
            <div class="date-range-validation-error">
              End date must be on or after the start date
            </div>
          }
          @if (awardSimulationForm.hasError('endBeforeStart')) {
            <div class="date-range-validation-error">
              End time must be after start time
            </div>
          }
        </mat-form-field>
      }

      <!-- Simulate Button -->
      <button mat-raised-button
              class="simulate-button"
              type="button"
              (click)="onSimulate()"
              [disabled]="awardSimulationForm.invalid"
              [id]="idPrefix + 'SimulateButton'"
              [attr.data-qa]="idPrefix + 'SimulateButton'"
              [attr.data-pw]="idPrefix + 'SimulateButton'">
        Simulate
      </button>
    </div>
  </form>
</div>

@if (simulationResults) {
  <div class="os-calculation"
       [attr.data-qa]="idPrefix + 'ResultsSection'"
       [attr.data-pw]="idPrefix + 'ResultsSection'">
    <div class="results-container"
         [attr.data-qa]="idPrefix + 'ResultsContainer'"
         [attr.data-pw]="idPrefix + 'ResultsContainer'">
      <div class="result-card"
           [attr.data-qa]="idPrefix + 'TotalFundingCard'"
           [attr.data-pw]="idPrefix + 'TotalFundingCard'">
        <div class="result-card-content">
          <p class="result-value"
             [attr.data-qa]="idPrefix + 'TotalFundingValue'"
             [attr.data-pw]="idPrefix + 'TotalFundingValue'">
            {{ simulationResults.totalFunding | currency }}
          </p>
          <p class="result-label"
             [attr.data-qa]="idPrefix + 'TotalFundingLabel'"
             [attr.data-pw]="idPrefix + 'TotalFundingLabel'">
            Amount of offers that shall be sent
          </p>
        </div>
      </div>

      <div class="result-card"
           [attr.data-qa]="idPrefix + 'AwardsCountCard'"
           [attr.data-pw]="idPrefix + 'AwardsCountCard'">
        <div class="result-card-content">
          <p class="result-value"
             [attr.data-qa]="idPrefix + 'AwardsCountValue'"
             [attr.data-pw]="idPrefix + 'AwardsCountValue'">
            {{ simulationResults.numberOfAwards }}
          </p>
          <p class="result-label"
             [attr.data-qa]="idPrefix + 'AwardsCountLabel'"
             [attr.data-pw]="idPrefix + 'AwardsCountLabel'">
            Number of Awards that shall be sent
          </p>
        </div>
      </div>

      <button mat-stroked-button
              class="send-awards-button"
              type="button"
              (click)="sendAwards()"
              [disabled]="!simulationResults?.recipients?.length"
              [attr.data-qa]="idPrefix + 'SendAwardsButton'"
              [attr.data-pw]="idPrefix + 'SendAwardsButton'">
        Send Awards
      </button>
    </div>

    @if (simulationResults?.recipients?.length) {
      <div class="recipients-section">
        <h3 class="recipients-title">List of Award Recipients</h3>
        <cfi-mat-table
          aria-label="award recipients list"
          [attr.data-pw]="idPrefix + 'RecipientsTable'"
          [attr.data-qa]="idPrefix + 'RecipientsTable'"
          [columnDefinitions]="columnDefinitions"
          [columnsToDisplayWithExpand]="displayedColumns"
          [data]="simulationResults.recipients || []"
          [displayedColumns]="displayedColumns"
          [sortKey]="sortColumn"
          [totalRows]="totalCount ?? 0"
          [currentPageIndex]="(currentPage ?? 1) - 1"
          [currentPageSize]="pageSize ?? 25"
          [pageSizeOptions]="pageSizeOptions"
          (cbPaginate)="onPageChange($event)"
          (cbSort)="onSortChange($event)">

          <ng-template #headerTemplate let-column>
            <div [attr.aria-label]="column.header" [attr.data-pw]="'header-' + column.name">
              {{ column.header }}
            </div>
          </ng-template>

          <ng-template #cellTemplate let-column="column" let-recipient>
            <div class="table-cell"
                 [attr.aria-label]="column.header + ': ' + recipient[column.name]"
                 [attr.data-pw]="'cell-' + column.name + '-' + recipient.pid">
              @switch (column.name) {
                @case('applicationDate') {
                  <div>{{ recipient[column.name] | date: 'MM/dd/yyyy' }}</div>
                }
                @case('awardAmount') {
                  <div>{{ recipient[column.name] | currency }}</div>
                }
                @case('action') {
                  <div class="action-buttons">
                    <button mat-icon-button
                            type="button"
                            [attr.aria-label]="isFlagged(recipient.studentId) ? 'Unflag recipient' : 'Flag recipient'"
                            [attr.aria-pressed]="isFlagged(recipient.studentId)"
                            [attr.data-qa]="'flag-button-' + recipient.studentId"
                            [attr.data-pw]="'flag-button-' + recipient.studentId"
                            (click)="toggleFlag(recipient)"
                            [class.flagged]="isFlagged(recipient.studentId)"
                            class="flag-button">
                      @if (isFlagged(recipient.studentId)) {
                        <mat-icon style="color: red;">flag</mat-icon>
                      } @else {
                        <mat-icon style="color: #1e3a5f;">outlined_flag</mat-icon>
                      }
                    </button>
                    @if (isFlagged(recipient.studentId)) {
                      <span class="flagged-label"
                            [attr.data-qa]="'flagged-label-' + recipient.studentId"
                            [attr.data-pw]="'flagged-label-' + recipient.studentId">
                        Flagged
                      </span>
                    }
                  </div>
                }
                @default {
                  {{ recipient[column.name] }}
                }
              }
            </div>
          </ng-template>
        </cfi-mat-table>
      </div>
    }
  </div>
}